<div mat-dialog-title align='center'>{{dialog_title}}</div>
<mat-dialog-content align='left' class='s18-font'>
  {{dialog_text}}<br/><br/>
</mat-dialog-content>
<div mat-dialog-actions align="center">
  <button mat-raised-button color='accent' [mat-dialog-close]='true'>{{dialog_action_desc}}
  </button>
  <button *ngIf='!dialog_hide_cancel' mat-button mat-dialog-close>Nevermind</button>
</div>